import store from '@/store/store';
import router from '@/router';
import { getFile } from '@/febos/servicios/api/dnt.api';
import {
  ioEDCreateRepository,
  ioEDEditRepository,
  ioEDFileSubscriptionsList,
  ioEDFoldersSubscriptionsList,
  ioEDPermissionsList,
  ioEDVersions,
  ioFilesAdd,
  ioFilesChangeOwner,
  ioFilesDelete,
  ioFilesList,
  ioFilesUpdate,
  ioFoldersAdd,
  ioFoldersBlock,
  ioFoldersChangeOwner,
  ioFoldersDelete,
  ioFoldersList, ioFoldersTemplate,
  ioFoldersUpdate,
  ioRepositoriesList
} from '@/febos/servicios/api/repositories.api';
import { clExecutionsListV2 } from '@/febos/servicios/api/v2.aprobaciones.api';
import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import PublicationStateTypes from '@/febos/global/documentManagement/mixins/PublicationStateTypes';
import ValidityStateTypes from '@/febos/global/documentManagement/mixins/ValidityStateTypes';
import { ioFilesSearch } from '@/febos/servicios/api/busqueda.api';

export const loadRepositories = async ({ commit }) => {
  try {
    commit('SET_LOADING', true);
    const response = await ioRepositoriesList();
    const repositories = response.data.repositorios.reduce((index, repo) => ({
      ...index,
      [repo.repositorioId]: repo
    }), {});
    commit('SET_REPOSITORIES', repositories);
  } finally {
    commit('SET_LOADING', false);
  }
};

export const loadTree = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_ELEMENTS', true);
    commit('SET_LOADING', true);
    const response = await ioFoldersList(payload);
    commit('SET_NESTED_FOLDERS', {
      repositoryId: payload.repositoryId,
      parentFolder: payload.parentFolder,
      folders: response.data.carpetas,
      fullpathId: response.data.fullpathId
    });
    // TODO: cargar los documentos relacionados al nivel seleccionado.
  } finally {
    commit('SET_LOADING', false);
    commit('SET_LOADING_ELEMENTS', false);
  }
};

export const blockFolder = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_ELEMENTS', true);
    await ioFoldersBlock({
      repositoryId: payload.repositoryId,
      folderId: payload.folderId,
      bloqueada: payload.bloqueada
    });
    commit('UPDATE_FOLDERBLOCK', {
      folderId: payload.folderId,
      blockEdit: payload.bloqueada
    });
  } finally {
    commit('SET_LOADING_ELEMENTS', false);
    commit('SET_SELECTED_ELEMENT', null);
    store.commit('Modals/CLOSE_MODAL');
  }
};

export const templateFolder = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_ELEMENTS', true);
    await ioFoldersTemplate({
      repositoryId: payload.repositoryId,
      folderId: payload.folderId,
      template: payload.template
    });
    commit('UPDATE_FOLDERTEMPLATE', {
      folderId: payload.folderId,
      template: payload.template
    });
  } finally {
    commit('SET_LOADING_ELEMENTS', false);
    commit('SET_SELECTED_ELEMENT', null);
    store.commit('Modals/CLOSE_MODAL');
  }
};

export const addFolder = async ({ commit }, payload) => {
  try {
    await ioFoldersAdd(payload);
    const folders = await ioFoldersList({
      repositoryId: payload.repositoryId,
      path: payload.to
    });
    commit('SET_NESTED_FOLDERS', {
      repositoryId: payload.repositoryId,
      parentFolder: payload.parentFolder,
      folders: folders.data.carpetas,
      fullpathId: folders.data.fullpathId,
    });
  } finally {
    store.commit('Modals/CLOSE_MODAL');
  }
};

export const updateFolder = async ({ commit }, payload) => {
  try {
    await ioFoldersUpdate(payload);
    commit('UPDATE_FOLDER', {
      folderId: payload.folderId,
      name: payload.name
    });
  } finally {
    commit('SET_SELECTED_ELEMENT', null);
    store.commit('Modals/CLOSE_MODAL');
  }
};

export const uploadFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_ELEMENTS', true);
    const newFileResponse = await ioFilesAdd(payload);
    // TODO: validar que los parametros sirvan para prod y cambiar el - por + en orden.
    const response = await ioFilesList({
      repositoryId: payload.repositoryId,
      params: {
        carpeta: payload.folderId || '/',
        pagina: 1,
        itemsPorPagina: 1000,
        orden: encodeURIComponent('+nombre'),
        stage: 'desarrollo',
        pais: 'cl'
      }
    });
    const newElements = response.data.archivos.map((file) => ({
      ...file,
      parentFolder: payload.folderId,
      repositoryId: payload.repositoryId,
      estadoVigencia: file.estadoVigencia || ValidityStateTypes.NOT_APPLY,
      estadoAprobacion: file.estadoAprobacion || ApprovalStateTypes.NOT_APPLY,
      estadoPublicacion: file.estadoPublicacion || PublicationStateTypes.DRAFT
    }));
    commit('LOAD_FILES', newElements);
    return newFileResponse;
  } finally {
    commit('SET_LOADING_ELEMENTS', false);
    store.commit('Modals/CLOSE_MODAL');
  }
};

export const updateFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_ELEMENTS', true);
    await ioFilesUpdate(payload);
    commit('UPDATE_FILE', {
      fileId: payload.file.archivoId,
      name: payload.file.nombre,
      isPublic: payload.file.esPublico,
      externalVersion: payload.file.versionExterna,
      publicationState: payload.file.estadoPublicacion,
      validityState: payload.file.estadoVigencia,
      approvalState: payload.file.estadoAprobacion,
      expirationType: payload.file.tipoExpiracion,
      expirationDate: payload.file.fechaVencimiento
    });
  } finally {
    commit('SET_LOADING_ELEMENTS', false);
    commit('SET_SELECTED_ELEMENT', null);
    store.commit('Modals/CLOSE_MODAL');
  }
};

export const loadFiles = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_ELEMENTS', true);
    // TODO: validar que los parametros sirvan para prod y cambiar el - por + en orden.
    const response = await ioFilesList({
      repositoryId: payload.repositoryId,
      params: {
        carpeta: payload.path,
        pagina: 1,
        itemsPorPagina: 1000,
        orden: encodeURIComponent('+nombre'),
        stage: 'desarrollo',
        pais: 'cl'
      }
    });
    const newElements = response.data.archivos.map((file) => ({
      ...file,
      parentFolder: payload.parentFolder,
      repositoryId: payload.repositoryId,
      estadoVigencia: file.estadoVigencia || ValidityStateTypes.NOT_APPLY,
      estadoAprobacion: file.estadoAprobacion || ApprovalStateTypes.NOT_APPLY,
      estadoPublicacion: file.estadoPublicacion || PublicationStateTypes.DRAFT
    }));
    commit('LOAD_FILES', newElements);
  } finally {
    commit('SET_LOADING_ELEMENTS', false);
  }
};

export const publishElement = async ({ commit }, payload) => {
  commit('SET_LOADING', true);
  commit('ENABLE_ELEMENT_TREE', payload);
  setTimeout(() => commit('SET_LOADING', false), 2000);
};

export const disableElement = async ({ commit }, payload) => {
  commit('SET_LOADING', true);
  commit('DISABLE_ELEMENT_TREE', payload);
  setTimeout(() => commit('SET_LOADING', false), 2000);
};

export const unSubscribeTo = async ({ commit }, payload) => {
  commit('SET_LOADING', true);
  commit('UNSUBSCRIBE_TO', payload);
  setTimeout(() => commit('SET_LOADING', false), 2000);
};

export const subscribeTo = async ({ commit }, payload) => {
  commit('SET_LOADING', true);
  console.log('ACTopm', payload);
  commit('SUBSCRIBE_TO', payload);
  setTimeout(() => commit('SET_LOADING', false), 2000);
};

export const goToFlow = async ({ commit }) => {
  commit('SET_LOADING', true);
  const path = '/documentos/flujo/68483ee2201b324e08295632f39fb0458e66';
  await router.push({ path });
  setTimeout(() => commit('SET_LOADING', false), 2000);
};

export const leaveComment = async ({ commit }, payload) => {
  commit('SET_LOADING', true);
  commit('ADD_COMMENT', payload);
  setTimeout(() => commit('SET_LOADING', false), 2000);
};

export const downloadFilePDF = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await getFile(payload);
    window.open(response.data.imagenLink, '_blank');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const setSelectedElement = ({ commit }, payload) => {
  commit('SET_SELECTED_ELEMENT', payload);
};

export const setSelectedRepository = ({ commit }, payload) => {
  commit('SET_SELECTED_REPOSITORY', payload);
  commit('SET_SELECTED_FOLDER_ID', null);
  commit('SET_SELECTED_ELEMENT', null);
};

export const setSelectedFolderId = ({ commit }, payload) => {
  commit('SET_SELECTED_REPOSITORY', null);
  commit('SET_SELECTED_FOLDER_ID', payload);
  commit('SET_SELECTED_ELEMENT', null);
};

export const cleanTreeView = ({ commit }) => {
  commit('SET_SELECTED_FOLDER_ID', null);
  commit('SET_SELECTED_REPOSITORY', null);
  commit('SET_SELECTED_ELEMENT', null);
  commit('SET_REPOSITORIES', {});
  commit('SET_FOLDERS_STACK', {});
  commit('SET_FILES_STACK', {});
  commit('SET_LOADING_ELEMENTS', false);
  commit('SET_LOADING', false);
};

export const removeFolder = async ({ commit }, payload) => {
  const resp = await ioFoldersDelete(payload);
  if (resp.data.codigo === 10) {
    commit('REMOVE_FOLDER', payload.folderId);
    commit('SET_SELECTED_ELEMENT', null);
  }
};

export const removeFile = async ({ commit }, payload) => {
  const resp = await ioFilesDelete(payload);
  if (resp.data.codigo === 10) {
    commit('REMOVE_FILE', payload.fileId);
    commit('SET_SELECTED_ELEMENT', null);
  }
};

export const setLoading = ({ commit }, payload) => {
  commit('SET_LOADING', payload);
};

export const setPermissionsStack = ({ commit }, payload) => {
  commit('SET_PERMISSIONS_STACK', payload);
};

export const loadPermissionsElement = async ({ commit }, payload) => {
  const response = await ioEDPermissionsList({
    elementId: payload.elementId,
    repositoryId: payload.repositoryId
  });
  commit('LOAD_PERMISSIONS_STACK', {
    elementId: payload.elementId,
    permissionsStack: response.data.permisos
  });
};

export const loadFileSubscriptions = async ({ commit }, payload) => {
  const response = await ioEDFileSubscriptionsList({
    params: {
      orden: encodeURIComponent('+fecha'),
      filtros: '',
      itemsPorPagina: 1000,
      pagina: 1,
      campos: 'id, nombre, correo'
    },
    repositoryId: payload.repositoryId,
    fileId: payload.fileId
  });
  commit('LOAD_SUBSCRIPTIONS_STACK', {
    id: payload.fileId,
    subscriptionsStack: response.data.suscritos
  });
};

export const loadFolderSubscriptions = async ({ commit }, payload) => {
  const response = await ioEDFoldersSubscriptionsList({
    params: {
      orden: encodeURIComponent('+fecha'),
      filtros: '',
      itemsPorPagina: 1000,
      pagina: 1,
      campos: 'id, nombre, correo'
    },
    repositoryId: payload.repositoryId,
    folderId: payload.folderId
  });
  commit('LOAD_SUBSCRIPTIONS_STACK', {
    id: payload.folderId,
    subscriptionsStack: response.data.suscritos
  });
};

export const loadApprovals = async ({ commit }, query) => {
  const response = await clExecutionsListV2(query);
  commit('SET_APPROVALS', response.data.aprobaciones);
};
export const changeFolderOwner = async (_, payload) => {
  await ioFoldersChangeOwner(payload);
};

export const changeFileOwner = async (_, payload) => {
  await ioFilesChangeOwner(payload);
};

export const getPreviousVersion = async ({ commit }, payload) => {
  const response = await ioEDVersions(payload);
  commit('SET_PREVIOUS_VERSIONS', response.data.versionesAnteriores);
};

export const createMainRepository = async ({ commit }) => {
  try {
    commit('SET_LOADING', true);
    await ioEDCreateRepository();
  } finally {
    commit('SET_LOADING', false);
  }
};

export const editMainRepository = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    await ioEDEditRepository(payload);
  } finally {
    commit('SET_LOADING', false);
  }
};

export const findTemplatesFolders = async ({ commit }) => {
  commit('SET_LOADING_TEMPLATES', true);
  try {
    const payload = {
      repositoryId: '0',
      params: {
        elementosPorPagina: 1000,
        pagina: 1,
        filtros: 'visualizadores:--usuario--,--grupos-y-padres--|template:1'
      }
    };
    const responseCarpetas = await ioFilesSearch(payload);
    return responseCarpetas.data;
  } finally {
    commit('SET_LOADING_TEMPLATES', false);
  }
};

export const findTemplatesFiles = async ({ commit }) => {
  commit('SET_LOADING_TEMPLATES', true);
  try {
    const foldersResponse = await findTemplatesFolders({ commit });
    const folderId = foldersResponse.documentos.map((folder) => folder.carpetaId).join(',');
    const payload = {
      repositoryId: '0',
      params: {
        elementosPorPagina: 1000,
        pagina: 1,
        filtros: `tipoObjeto:1|visualizadores:--usuario--,--grupos-y-padres--|carpetaId:${folderId}`
      }
    };
    const responseArchivos = await ioFilesSearch(payload);
    return responseArchivos.data;
  } finally {
    commit('SET_LOADING_TEMPLATES', false);
  }
};
